<template>
    <div id="VoucherTemplate">
        <el-card>
            <div class="AdminTopOper">
                <el-space wrap :size="15">
                    <el-input v-model="pageData.searchKey" placeholder="请输入订单号"></el-input>
                    <el-input style="width: 120px" v-model="pageData.where.id" placeholder="请输入ID"></el-input>
                    <el-button type="primary" icon="Search" @click="orderSearce()">搜索</el-button>
                    <el-button type="primary" icon='Plus' @click="pageData.handleCreate()">新建</el-button>


                </el-space>
            </div>
            <!-- 表格主体 -->
            <el-table :data="pageData.rows">
                <el-table-column prop="id" label="编号" width="100" />
                <el-table-column label="优惠名称" width="150">
                    <template #default="scope">
                        {{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="优惠券类型" width="180">
                    <template #default="scope">
                        {{ scope.row.type }}
                    </template>
                </el-table-column>
                <el-table-column label="优惠规则" width="200">
                    <template #default="scope">
                        {{ scope.row.rules }}
                    </template>
                </el-table-column>
                <el-table-column label="启用状态" width="100">
                    <template #default="scope">
                      
                        <el-tag v-if="scope.row.isEnabled" type="success">启用</el-tag>
                        <el-tag v-if="!scope.row.isEnabled" type="error">禁用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="库存数量" width="100">
                    <template #default="scope">
                        {{ scope.row.totalStock }}
                    </template>
                </el-table-column>
                <AdminTableButton :showEdit="true" width="200" fixed="right"> </AdminTableButton>
            </el-table>

            <AdminPagination :showEdit="false"> </AdminPagination>
        </el-card>


        <!-- 新建与编辑dialog -->
        <el-dialog v-model="pageData.dialogVisible" title="新建" width="800px">
            <el-form ref="form" :model="pageData.row" label-width="100px" size='medium'>
                <el-form-item label="优惠名称">
                    <el-input v-model="pageData.row.name"></el-input>
                </el-form-item>
                <el-form-item label="优惠类型">
                    <el-input v-model="pageData.row.type"></el-input>
                </el-form-item>
                <el-form-item label="使用规则">
                    <el-input v-model="pageData.row.ruleText"></el-input>
                </el-form-item>
                <el-form-item label="指定类型">
                    <el-input v-model="pageData.row.setting"></el-input>
                </el-form-item>
                <el-form-item label="规则类型">
                    <el-input v-model="pageData.row.ruletype"></el-input>
                </el-form-item>
                <el-form-item label="规则说明">
                    <el-input v-model="pageData.row.rulelimitText"></el-input>
                </el-form-item>
                <el-form-item label="折扣">
                    <el-input v-model="pageData.row.discountValue"></el-input>
                </el-form-item>
                <el-form-item label="最少金额">
                    <el-input v-model="pageData.row.minOrderAmount"></el-input>
                </el-form-item>
                <el-form-item label="优惠金额">
                    <el-input v-model="pageData.row.discountAmount"></el-input>
                </el-form-item>
                <el-form-item label="最大优惠金额">
                    <el-input v-model="pageData.row.MaxdiscountAmount"></el-input>
                </el-form-item>
                <el-form-item label="background">
                    <el-input v-model="pageData.row.background"></el-input>
                </el-form-item>
                <el-form-item label="useCount">
                    <el-input v-model="pageData.row.useCount"></el-input>
                </el-form-item>
                <!-- <el-form-item label="启用状态">
                    <el-input v-model="pageData.row.isEnabled"></el-input>
                </el-form-item>
                <el-form-item label="库存数量">
                    <el-input v-model="pageData.row.totalStock"></el-input>
                </el-form-item> -->



            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="pageData.dialogVisible = false">Cancel</el-button>
                    <el-button type="primary" @click="pageData.create()">Confirm</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { onMounted, onUpdated, reactive, ref, watch } from 'vue'
import Api from '@/network'
const pageData = reactive(Api.adminPage('VoucherTemplate'))
pageData.where.count = null
onMounted(pageData.getPage())


</script>



<style lang="less"></style>